<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}->{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="班级/教职评价审批" name="first">
                <child1></child1>
            </el-tab-pane>
    
            <el-tab-pane label="学生/课堂/成果/实践评价审批" name="second">
                <child2></child2>    
            </el-tab-pane>
            
        </el-tabs>
    </div>
</template>

<script>
    import ClassEvaluateCheck from './ClassEvaluateCheck.vue'
    import StudentEvaluateCheck from './StudentEvaluateCheck.vue'

    export default {
        name:"EvaluateCheckMain",
        components:{
            child1:ClassEvaluateCheck,
            child2:StudentEvaluateCheck,
        },
        data() {
            return {
                menuName:"",
                //默认第一个选项卡
                activeName: "first",
                title:"班级/教职评价审批"
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
        },
        methods:{
            handleClick(tab) {
                if(tab.name == "first") {
                    this.title="班级/教职评价审批";
                }else if(tab.name == "second") {
                    this.title="学生/课堂/成果/实践评价审批";
                }
            }
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/EvaluateCheckMain.vue